import React from 'react';
import { Card, Tag, Typography } from 'antd';
import { CalendarOutlined, FileTextOutlined, DollarOutlined, RightOutlined } from '@ant-design/icons';
import CurrencyFormat from 'react-currency-format';
import dayjs from 'dayjs';
import './ClaimsBatchCard.css';

const { Text } = Typography;

/**
 * Formats encounter date for display
 */
const formatEncounterDate = (dateString) => {
  const date = dayjs(dateString);
  return {
    day: date.format('D'),
    monthYear: date.format('MMM YYYY'),
    full: date.format('MMMM D, YYYY')
  };
};

/**
 * ClaimsBatchCard - Displays a single batch card
 * 
 * @param {Object} props
 * @param {Object} props.batch - Batch data { encounter_date, claims_count, total_cost }
 * @param {Function} props.onClick - Click handler
 */
const ClaimsBatchCard = ({ batch, onClick }) => {
  if (!batch) return null;

  const dateInfo = formatEncounterDate(batch.encounter_date);

  return (
    <Card
      className="claims-batch-card"
      hoverable
      onClick={onClick}
      style={{
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s',
      }}
    >
      <div className="batch-card__content">
        {/* Date section - prominent */}
        <div className="batch-card__date">
          <div className="batch-card__date-day">{dateInfo.day}</div>
          <div className="batch-card__date-month">{dateInfo.monthYear}</div>
        </div>

        {/* Stats section */}
        <div className="batch-card__stats">
          <div className="batch-card__claims-count">
            <FileTextOutlined style={{ marginRight: '4px' }} />
            <Tag color="blue" style={{ margin: 0 }}>
              {batch.claims_count}
            </Tag>
            <Text type="secondary" style={{ fontSize: '12px', marginLeft: '4px' }}>
              {batch.claims_count === 1 ? 'claim' : 'claims'}
            </Text>
          </div>
          <div className="batch-card__total-cost">
            <DollarOutlined style={{ marginRight: '4px' }} />
            <CurrencyFormat
              value={batch.total_cost || 0}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'₦'}
              decimalScale={2}
            />
          </div>
        </div>

        {/* Action indicator */}
        <div className="batch-card__action">
          <RightOutlined />
        </div>
      </div>
    </Card>
  );
};

export default ClaimsBatchCard;

